<p-dialog header="Delete Advance Rule" [visible]="visible" (visibleChange)="visibleChange.emit($event)" [style]="{ width: '50vw' }" (onHide)="onCloseDialog()">

  <p>Do you want to delete the following firewall rules?</p>
  <ul class="two-column">
    <li *ngFor="let rule of rulesToBeRemoved">
      <p>Protocol: {{ rule.protocol }}</p>
      <p>Destination: {{ rule.ipAddress }}</p>
      <p>Destination Port: {{ rule.destinationPort }}</p>
      <p>Source Port: {{ rule.sourcePort }}</p>
    </li>
  </ul>

  <ng-template pTemplate="footer">
    <p-button icon="fas fa-trash"
              (onClick)="delete()"
              label="Delete"
              styleClass="p-button-danger">
    </p-button>
  </ng-template>

</p-dialog>
